import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "antd";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DocumentBrowsing from "../general/DocumentBrowsing/index";
import { useSelector, useDispatch } from "react-redux";
import {
  getLinkedDocuments,
  saveLinkedDocuments
} from "../../store/actions/documentsWithSearch/index";
import { getIconByType } from "../../libs/documentsUtils";
import CustomChip from "../general/chips/index";
import "./style.css";

const LinkedDocumentsPanel = ({
  isModalVisible,
  setIsModalVisible,
  accountantSelected,
  accountantIdSelected,
  companySelected,
  clientIdSelected,
  documentId  
}) => {
  const navigate = useNavigate();
  const documents = useSelector(state => state.documents);
  const linkedDocumentsData = useSelector(state => state.documentsWithSearch.linkedDocumentsData);
  const documentsTypes = useSelector(state =>
    state.documents && state.documents.classification
      ? state.documents.classification.typesDocuments
      : null);
  const [documentsIds, setDocumentsIds] = useState({ documents: [] });
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isErrorData, setIsErrorData] = useState(false);
  const [linkedDocumentsArr, setLinkedDocumentsArr] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {

    dispatch(getLinkedDocuments(documentId));
  }, [documentId]);

  useEffect(() => {
    if (linkedDocumentsData !== null) {
      const linkedDocumentsDataStatus = linkedDocumentsData.status;
      setIsLoadingData(linkedDocumentsDataStatus.started === true ? true : false);
      setIsErrorData(linkedDocumentsDataStatus.error === true ? true : false);
      if (
        linkedDocumentsDataStatus.ended === true &&
        linkedDocumentsDataStatus.error === false
      ) {
        setLinkedDocumentsArr([...linkedDocumentsData.linkedDocuments]);
      }
    }
  }, [linkedDocumentsData]);

  useEffect(() => {
    setDocumentsIds({ documents: [...linkedDocumentsArr] });
  }, [linkedDocumentsArr]);

  const onSaveLinkedDoc = () => {
    dispatch(saveLinkedDocuments(documentId,
      documentsIds));
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setLinkedDocumentsArr([...linkedDocumentsData.linkedDocuments]);
  };

  const addSelectedDocument = e => {
    setDocumentsIds({
      documents: [
        ...documentsIds.documents,
        ...linkedDocumentsData.linkedDocuments,
        { documentId: e.documentId }
      ]
    });
    const linkedDocumentsCopy = [...linkedDocumentsArr];
    const docToBeAdded = e;
    const duplicatedDoc = linkedDocumentsCopy.find(doc => doc.documentId === docToBeAdded.documentId);
    if (duplicatedDoc === undefined) {
      linkedDocumentsCopy.push(docToBeAdded);
    }
    setLinkedDocumentsArr([...linkedDocumentsCopy]);
  };

  const removeLinkedDoc = documentId => {
    const linkedDocumentsCopy = [...linkedDocumentsArr];
    const docToBeRemoved = linkedDocumentsCopy.find(doc => doc.documentId === documentId);
    const filteredLinkedDocumentsCopy = linkedDocumentsCopy.filter(doc => doc !== docToBeRemoved);
    setLinkedDocumentsArr([...filteredLinkedDocumentsCopy]);
  };

  const renderLinkedDocumentsChips = () => {
    return (
      <div className="linkedDocChipsContainer">
        {linkedDocumentsArr.map((doc, index) => {
          return (
            <CustomChip
              key={index}
              description={doc.fileName ? doc.fileName : doc.filename}
              closable={true}
              style={{ maxWidth: "250px", marginBottom: "12px" }}
              onClose={() => removeLinkedDoc(doc.documentId)}
            />
          );
        })}
      </div>
    );
  };

  const goToLinkedDocDetail = documentId => {
    navigate("/dettaglio-documento/" + documentId);
  };

  const renderLinkedDocumentsList = () => {
    return linkedDocumentsArr.map((doc, index) => {
      return (
        <div
          key={index}
          className="linkedDocRow"
          onClick={() => goToLinkedDocDetail(doc.documentId)}
        >
          <div className="docTitle">
            <FontAwesomeIcon
              icon={[
                "far",
                getIconByType(doc.fileName ? doc.fileName : doc.filename,
                  documentsTypes)
              ]}
              style={{
                fontSize: "18px",
                marginRight: "8px",
                color: "rgb(21, 41, 53)"
              }}
            />
            <span className="linkedDocFileName">
              {doc.fileName ? doc.fileName : doc.filename}
            </span>
          </div>
          <FontAwesomeIcon
            icon={["far", "arrow-right"]}
            style={{ fontSize: "16px", color: "rgb(0, 144, 209)" }}
          />
        </div>
      );
    });
  };

  return (
    <>
      <Modal
        title={<FormattedMessage id="documents.detail.linkedDocModalTitle" />}
        visible={isModalVisible}
        onOk={onSaveLinkedDoc}
        onCancel={handleCancel}
        maskClosable={false}
        cancelText={
          <FormattedMessage id="documents.detail.linkedDocModalCancelButton" />
        }
        okText={
          <FormattedMessage id="documents.detail.linkedDocModalSaveButton" />
        }
        zIndex={1000000}
        wrapClassName="linkedDocModalContainer"
      >
        {
          <>
            <DocumentBrowsing
              accountantSelected={accountantSelected}
              accountantIdSelected={accountantIdSelected}
              companySelected={companySelected}
              clientIdSelected={clientIdSelected}
              fullWidth={true}
              id={"linkedDocBrowsing"}
              selected={documents}
              addDocument={e => addSelectedDocument(e)}
              width="100%"
              isDocumentDetails={true}
              currentDocumentId={documentId}
            />

            {linkedDocumentsArr.length > 0 && renderLinkedDocumentsChips()}
          </>
        }
      </Modal>
      {isLoadingData || isErrorData ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "0 auto"
          }}
        >
          <FontAwesomeIcon
            icon={["far", "circle-notch"]}
            spin
            style={{ color: "#0090d1", fontSize: "32px" }}
          />
        </div>
      ) : linkedDocumentsArr.length === 0 ? (
        <span>
          <FormattedMessage id="documents.detail.linkedDocEmpty" />
        </span>
      ) : (
        renderLinkedDocumentsList()
      )}
    </>
  );
};

export default LinkedDocumentsPanel;
